import { createController, createControllerEndpoint } from 'src/utils/api';

export type MfaDataType = {
    key: string,
    url: string
}

export default createController('/api/v1/users', {
    updateMyProfile: createControllerEndpoint<void>('PUT', '/me'),
    getOtpMfaSetup: createControllerEndpoint<any>('GET', '/me/mfa/otp'),
    getMfaMethods: createControllerEndpoint<any>('GET', '/me/mfa'),
    confirmOtpMfa: createControllerEndpoint<any>('POST', '/me/mfa/otp'),
    removeMfa: createControllerEndpoint<any>('POST', '/me/mfa/clear'),
    deleteMyProfile: createControllerEndpoint<void>('DELETE', '/me'),
});